import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
const navLinks = [{
  label: 'Services',
  href: '#services'
}, {
  label: 'Our Work',
  href: '#gallery'
}, {
  label: 'Why Us',
  href: '#why-us'
}, {
  label: 'Contact',
  href: '#contact'
}];
export function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handler);
    return () => window.removeEventListener('scroll', handler);
  }, []);
  const handleNav = (href: string) => {
    setOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-[#0d1117] shadow-lg shadow-black/40' : 'bg-[#0d1117]/80 backdrop-blur-md'}`} data-id="element-107">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 flex items-center justify-between h-16" data-id="element-108">
        {/* Logo */}
        <a href="#" onClick={() => window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })} className="flex items-center gap-3" data-id="element-109">
          <img src="https://cdn.magicpatterns.com/uploads/iZx6wcW2kMqVcgUNkeyzh3/elitepoolz.jpg" alt="Elite Poolz logo" className="h-10 w-10 rounded-full object-cover" data-id="element-110" />
          <span className="font-bold text-lg tracking-wide hidden sm:block" data-id="element-111">
            <span className="text-gray-300" data-id="element-112">ELITE</span>{' '}
            <span className="text-[#2979ff]" data-id="element-113">POOLZ</span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-114">
          {navLinks.map(link => <button key={link.href} onClick={() => handleNav(link.href)} className="text-gray-300 hover:text-[#2979ff] transition-colors text-sm font-medium tracking-wide" data-id="element-115">
              {link.label}
            </button>)}
          <a href="tel:+1" className="flex items-center gap-2 bg-[#2979ff] hover:bg-[#1a5fd4] text-white px-4 py-2 rounded-lg text-sm font-semibold transition-colors" data-id="element-116">
            <Phone size={14} data-id="element-117" />
            Get a Quote
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button className="md:hidden text-white p-2" onClick={() => setOpen(!open)} aria-label="Toggle menu" data-id="element-118">
          {open ? <X size={24} data-id="element-119" /> : <Menu size={24} data-id="element-120" />}
        </button>
      </div>

      {/* Mobile menu */}
      {open && <div className="md:hidden bg-[#0d1117] border-t border-[#1e2a3a] px-4 pb-6 pt-4 flex flex-col gap-4 text-center" data-id="element-121">
          {navLinks.map(link => <button key={link.href} onClick={() => handleNav(link.href)} className="text-gray-300 hover:text-[#2979ff] transition-colors text-base font-medium py-1" data-id="element-122">
              {link.label}
            </button>)}
          <a href="tel:+1" className="flex items-center gap-2 bg-[#2979ff] hover:bg-[#1a5fd4] text-white px-4 py-3 rounded-lg text-sm font-semibold transition-colors justify-center mt-2" data-id="element-123">
            <Phone size={14} data-id="element-124" />
            Get a Quote
          </a>
        </div>}
    </header>;
}